/**
 * KAN-744: менеджер клиента в карточке клиента. Выбор сохраняется сразу
 * (PATCH /clients/{id}/ manager_id; "Не назначен" -> null). Ошибка сохранения
 * (например, менеджер ушёл в архив) показывается под селектом.
 * KAN-828: обычный менеджер не меняет менеджера чужого клиента: выбор
 * недоступен с подсказкой (useClientManagerRights).
 */
import { ManagerSelect } from '@/components/managers/ManagerSelect';
import { assignErrorMessage } from '@/components/managers/assignErrorMessage';
import { useClientManagerRights } from '@/hooks/useClientManagerRights';
import { useAssignClientManager } from '@/hooks/useManagers';
import type { ManagerBrief } from '@/types/manager';

interface Props {
  clientId: string;
  manager: ManagerBrief | null | undefined;
}

export function ClientManagerSelect({ clientId, manager }: Props): JSX.Element {
  const assign = useAssignClientManager(clientId);
  const rights = useClientManagerRights(manager?.id);
  return (
    <div className="flex items-start justify-between gap-3" data-testid="client-manager">
      <span className="shrink-0 pt-2 text-sm text-gray-500">Менеджер</span>
      <div className="w-56 max-w-full">
        <ManagerSelect
          value={manager}
          onSelect={(id) => assign.mutate(id)}
          disabled={!rights.canChange}
          pending={assign.isPending}
          error={assignErrorMessage(assign.error)}
          testId="client-manager-select"
        />
        {rights.lockedHint && (
          <p className="mt-1 text-xs text-gray-500" data-testid="client-manager-locked">
            {rights.lockedHint}
          </p>
        )}
      </div>
    </div>
  );
}
